import { useLazyReadMonitorsShortQuery } from "services/monitor/qmonitor"

export const useSpyHasCompletedLaunches = () => {
    const [lazyReadMonitorsShortQuery] = useLazyReadMonitorsShortQuery()

    const spyHasCompletedLaunches = async (spyId: number) => {
        const lazyReadHostServiceListByMonitorIdQueryResult = await lazyReadMonitorsShortQuery()

        if (lazyReadHostServiceListByMonitorIdQueryResult.data === undefined){
          return false
        }

        if (lazyReadHostServiceListByMonitorIdQueryResult.data.count === 0){
          return false
        }

        const foundItem = lazyReadHostServiceListByMonitorIdQueryResult.data.list
          .find((item: any) => item.id === spyId) 

        if (foundItem === undefined){
          return false
        }

        if (foundItem.runsCount === 0){
          return false
        }
       
        return true
    }

  return {
    spyHasCompletedLaunches
  }
}